import { useState } from 'react';
import { LoadingButton } from 'foundations-components/transitional/components/LoadingButton';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { jsx as _jsx } from "react/jsx-runtime";
function ObjectIdDelayButton() {
  const [loading, setLoading] = useState(false);
  return /*#__PURE__*/_jsx(LoadingButton, {
    loading: loading,
    use: "primary",
    onClick: () => {
      setLoading(true);
    },
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "productApprovals.modal.action.REQUEST"
    })
  });
}
export default ObjectIdDelayButton;